<template>

  <form v-on:submit.prevent="saveName(candidate)" style="width: 100%">
    <div class="mb-1">
      <input
        v-autofocus
        type="text"
        class="form-control form-control-lg"
        :placeholder="$t('Name')"
        v-model="candidate.name">
      <ValidateMessage :error="validateErrors.name" />
    </div>
    <div class="mb-3">
      <input
        type="text"
        class="form-control"
        :placeholder="$t('Headline')"
        v-model="candidate.headline">
      <ValidateMessage :error="validateErrors.headline" />
    </div>
    <div :class="{'box-loading': loading}">
      <button
        type="submit"
        class="btn btn-sm btn-primary">
        {{ $t('Save') }}
        </button>
      <button
        type="button"
        class="btn btn-sm btn-light"
        @click="cancelEditName">
        {{ $t('Cancel') }}
      </button>  
    </div>
  </form>

</template>

<script>
export default {
  name: 'CandidateHeaderForm',
  components: {
  },
  props: [
    'initCandidate'
  ],
  data () {
    return {
      validateErrors: false,
      loading: false,
      candidate: this.$clone(this.initCandidate)
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    cancelEditName () {
      this.$emit('cancel')
    },
    saveName (data) {
      this.loading = true

      this.$store
      .dispatch('updateCandidate', data)
      .then((response) => {
        this.loading = false
        this.$emit('saved', response)
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Candidate/Header/CandidateNameForm.vue